import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import {
  interactionsTypeActions,
  severitiesActions,
  probabilitiesActions,
  messageActions
} from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import ChipInput from 'material-ui-chip-input'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import * as API from '../../api'
import TextField from '@material-ui/core/TextField'
import SelectWrapped from '../../components/SelectWrapped'
import Chip from '@material-ui/core/Chip'
import { formatContentSelectValue, filterOptionsFunction } from '../../utils'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  componentDidMount() {
    const { fetchSeveritiesAll } = this.props
    fetchSeveritiesAll()

    const { fetchProbabilitiesAll } = this.props
    fetchProbabilitiesAll()
  }

  handleSave = interactionType => {
    const { onClose, addInteractionType, editInteractionType, changeMessage } = this.props
    if (interactionType._id) {
      editInteractionType(interactionType).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addInteractionType(interactionType).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, interactionType) => {
    e.preventDefault()
    const { setInteractionTypeFormTouched } = this.props
    if ((this.props.interactionTypeFormErrors || {}).valid) {
      this.handleSave(interactionType)
    } else {
      setInteractionTypeFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      interactionType,
      severities,
      probabilities,
      handleChangeInteractionType,
      loadingInteractionType,
      interactionTypeFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('interacoes_tipo', token)

    return (
      <div>
        <Dialog
          modalId={interactionType._id ? 'tipos-interacao-editar' : 'tipos-interacao-novo'}
          modalParams={{ registro: interactionType._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingInteractionType ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(interactionType._id ? 'tipos-interacao-editar' : 'tipos-interacao-novo') + '-title'}>
                {isReadOnly ? (
                  'Interacoes_Tipo'
                ) : (
                  <Fragment>
                    {interactionType._id
                      ? 'Editar tipo de interação'
                      : 'Cadastrar Tipo de Interação'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'interactionType-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, interactionType)
                  }}
                >
                  <FormControl
                    error={
                      !((interactionTypeFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({ ...interactionType, nome: e.target.value })
                      }}
                      value={interactionType.nome}
                      autoFocus
                      id="field-nome"
                    />

                    {!((interactionTypeFormErrors.fields || {})['nome'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((interactionTypeFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionTypeFormErrors.fields || {})['efeito'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-efeito">Efeito</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({
                          ...interactionType,
                          efeito: e.target.value
                        })
                      }}
                      value={interactionType.efeito}
                      id="field-efeito"
                    />

                    {!((interactionTypeFormErrors.fields || {})['efeito'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((interactionTypeFormErrors.fields || {})['efeito'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Gravidade</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={
                        !((interactionTypeFormErrors.fields || {})['gravidade'] || {}).valid &&
                        formTouched
                      }
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({
                          ...interactionType,
                          gravidade_id: e.target.value
                        })
                      }}
                      value={interactionType.gravidade_id || ''}
                    >
                      {!!(severities != undefined) &&
                        (severities || []).map(gravidade => (
                          <MenuItem key={gravidade._id} value={gravidade._id}>
                            {gravidade.nome}
                          </MenuItem>
                        ))}
                    </Select>
                    {!((interactionTypeFormErrors.fields || {})['gravidade'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((interactionTypeFormErrors.fields || {})['gravidade'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl fullWidth className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">Probabilidade</InputLabel>
                    <Select
                      disabled={isReadOnly}
                      error={
                        !((interactionTypeFormErrors.fields || {})['probabilidade'] || {}).valid &&
                        formTouched
                      }
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({
                          ...interactionType,
                          probabilidade_id: e.target.value
                        })
                      }}
                      value={interactionType.probabilidade_id || ''}
                    >
                      {!!(probabilities != undefined) &&
                        (probabilities || []).map(probabilidade => (
                          <MenuItem key={probabilidade._id} value={probabilidade._id}>
                            {probabilidade.nome}
                          </MenuItem>
                        ))}
                    </Select>
                    {!((interactionTypeFormErrors.fields || {})['probabilidade'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((interactionTypeFormErrors.fields || {})['probabilidade'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionTypeFormErrors.fields || {})['mecanismoProvavel'] || {})
                        .valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-mecanismoProvavel">Mecanismo Provável</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({
                          ...interactionType,
                          mecanismoProvavel: e.target.value
                        })
                      }}
                      value={interactionType.mecanismoProvavel}
                      id="field-mecanismoProvavel"
                    />

                    {!((interactionTypeFormErrors.fields || {})['mecanismoProvavel'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((interactionTypeFormErrors.fields || {})['mecanismoProvavel'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionTypeFormErrors.fields || {})['referencias'] || []).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <TextField
                      disabled={isReadOnly}
                      fullWidth
                      onChange={obj => {
                        handleChangeInteractionType({ ...interactionType, referencias: obj })
                      }}
                      error={
                        !((interactionTypeFormErrors.fields || {})['referencias'] || []).valid &&
                        formTouched
                      }
                      value={formatContentSelectValue(interactionType.referencias || [])}
                      placeholder="Selecione..."
                      name="react-select-chip-label"
                      label="Referências"
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{
                        inputComponent: SelectWrapped,
                        inputProps: {
                          multi: true,
                          filterOptions: filterOptionsFunction,
                          instanceId: 'react-select-chip-label',
                          id: 'react-select-chip-label',
                          loadOptions: API.references.getSelectReferences,
                          disableDelete: isReadOnly
                        }
                      }}
                    />
                    {!((interactionTypeFormErrors.fields || {})['referencias'] || []).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((interactionTypeFormErrors.fields || {})['referencias'] || [])
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionTypeFormErrors.fields || {})['tempoInicio'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-tempoInicio">Tempo Início</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({
                          ...interactionType,
                          tempoInicio: e.target.value
                        })
                      }}
                      value={interactionType.tempoInicio}
                      id="field-tempoInicio"
                    />

                    {!((interactionTypeFormErrors.fields || {})['tempoInicio'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((interactionTypeFormErrors.fields || {})['tempoInicio'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((interactionTypeFormErrors.fields || {})['sugestaoManejo'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-sugestaoManejo">Sugestão Manejo</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeInteractionType({
                          ...interactionType,
                          sugestaoManejo: e.target.value
                        })
                      }}
                      value={interactionType.sugestaoManejo}
                      id="field-sugestaoManejo"
                    />

                    {!((interactionTypeFormErrors.fields || {})['sugestaoManejo'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {
                          ((interactionTypeFormErrors.fields || {})['sugestaoManejo'] || {})
                            .errorMessage
                        }
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'interactionType-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    interactionType: state.interactionsType.interactionType,
    severities: state.severities.severities,
    probabilities: state.probabilities.probabilities,
    loadingInteractionType: state.interactionsType.loadingInteractionType,
    interactionTypeFormErrors: state.interactionsType.interactionTypeFormErrors,
    formTouched: state.interactionsType.interactionTypeFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(interactionsTypeActions.openModal())
    },
    closeModal: () => {
      dispatch(interactionsTypeActions.closeModal())
    },
    handleChangeInteractionType: interactionType => {
      dispatch(interactionsTypeActions.handleChangeInteractionType(interactionType))
    },
    addInteractionType: interactionType => {
      return dispatch(interactionsTypeActions.addInteractionType(interactionType))
    },
    editInteractionType: interactionType => {
      return dispatch(interactionsTypeActions.editInteractionType(interactionType))
    },
    setInteractionTypeFormTouched: interactionType => {
      dispatch(interactionsTypeActions.setInteractionTypeFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    fetchSeveritiesAll: options => {
      dispatch(severitiesActions.fetchSeveritiesAll(options))
    },
    fetchProbabilitiesAll: options => {
      dispatch(probabilitiesActions.fetchProbabilitiesAll(options))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/InteractionsType/EditModal.js